import { FilterMatchMode } from "primereact/api";
import { PagingConstants } from "./PagingConstants";

export const INITIAL_LAZY_REPORT_STATE = {
  first: 0,
  rows: PagingConstants.INITIAL_ROW_AMOUNT,
  page: 1,
  sortField: "name",
  sortOrder: -1,
  multiSortMeta: [{ field: "name", order: -1 }],
  filters: {
    name: { value: null, matchMode: FilterMatchMode.CONTAINS },
    created: { value: null, matchMode: FilterMatchMode.DATE_IS },
    updated: { value: null, matchMode: FilterMatchMode.DATE_IS },
    description: { value: null, matchMode: FilterMatchMode.CONTAINS },
    substations: { value: null, matchMode: FilterMatchMode.CONTAINS },
    complete: { value: null, matchMode: FilterMatchMode.EQUALS },
  },
};
